import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ROUTES } from "../constants";

interface NavLink {
  exact: boolean;
  path: string;
  title: string;
  icon?: string;
}

export interface NavbarState {
  show: boolean;
  showOnSmScreen: boolean;
  showLinksOnSmScreen: boolean;
  showMyConselorsNavBtn: boolean;
  links: NavLink[];
}

export interface LayoutState {
  navbar: NavbarState;
  showWizardBtn: boolean;
}

const initialState: LayoutState = {
  navbar: {
    show: true,
    showOnSmScreen: true,
    showLinksOnSmScreen: true,
    showMyConselorsNavBtn: false,
    links: [
      {
        exact: true,
        path: ROUTES.MICROSCOPIC_PLAN.PATH,
        title: "برنامه میکروسکوپی",
        icon: "fas_fa_microscope",
      },
      { exact: true, path: ROUTES.TIMING_PLAN.PATH, title: "روتین هفتگی" },
      { exact: true, path: ROUTES.BOOK_MANAGEMENT.PATH, title: "کتابخانه" },
      {
        exact: true,
        path: ROUTES.TELESCOPIC_PLAN.PATH,
        title: "آنالیز تلسکوپی",
      },
    ],
  },
  showWizardBtn: false,
};

export const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    changeLinksAction: (state, action: PayloadAction<NavLink[]>) => {
      state.navbar.links = action.payload;
    },
    addLinksAction: (state, action: PayloadAction<NavLink>) => {
      state.navbar.links.push(action.payload);
    },
    setShowAction: (state, action: PayloadAction<boolean>) => {
      state.navbar.show = action.payload;
    },
    setShowOnSmScreenAction: (state, action: PayloadAction<boolean>) => {
      state.navbar.showOnSmScreen = action.payload;
    },
    setShowLinksOnSmScreenAction: (state, action: PayloadAction<boolean>) => {
      state.navbar.showLinksOnSmScreen = action.payload;
    },
    resetLinksAction: (state) => {
      state.navbar.links = initialState.navbar.links;
    },
    setShowMyConselorsBtnAction: (state, action: PayloadAction<boolean>) => {
      state.navbar.showMyConselorsNavBtn = action.payload;
    },
    setShowWizardBtnAction: (state, action: PayloadAction<boolean>) => {
      state.showWizardBtn = action.payload;
    },
  },
});

export const {
  addLinksAction,
  changeLinksAction,
  resetLinksAction,
  setShowAction,
  setShowLinksOnSmScreenAction,
  setShowMyConselorsBtnAction,
  setShowOnSmScreenAction,
  setShowWizardBtnAction,
} = navbarSlice.actions;

export default navbarSlice.reducer;
